package de.oevbs.kunde.kundenportal2.validation

import dev.fritz2.core.Inspector
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.headless.validation.Severity

/**
 * Enthält häufig benutzte Reguläre Ausdrücke.
 * Der Ausdruck für die Validierung wird aus der BaseLib genommen und ist daher nicht aufgelistet.
 */
object Regexes {

    // first/lastname/street/city, mindestens 2 Zeichen, darf -. enthalten aber nicht damit anfangen
    val name = Regex("^[a-zA-Z\\u00C0-\\u017F]+[\\u00C0-\\u017F\\sa-zA-Z-`´'.]+")

    // 4-20 alphanumerische Zeichen, darf _-.@ enthalten aber nicht damit anfangen, darf kein €: enthalten
    val userName = Regex("^[a-zA-Z]+[a-zA-Z0-9@._-]{3,20}")
    val phoneNumber = Regex("""\+?[\d /-]{6,}""")
    // 8-20 Zeichen, mind. 1 Zahl, mind. Großbuchstabe, mind. 1 Kleinbuchstabe, alles andere ok außer €:
    val password = Regex("^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?!.*[€:]).{8,20}$")

    val streetNumber = Regex("""[0-9]{1,4}[ ]?[a-zA-Z]?""")
    val postalCode = Regex("""[0-9]{5}""")

    val policyId = Regex("[a-zA-Z0-9-/\\w]{8,20}")
    val partnerId = Regex("[0-9]{1,7}")

    val startsWithNumber = Regex("^[0-9].*$")
}

/**
 * Erweitert den Inspector in Validierungsfunktionen um eine Prüfung gegen eine Regex.
 * Verwendet die im [KupoValidationMessages] Objekt definierten Nachrichten als Default-Nachricht für
 * leere bzw. ungültige Eingaben.
 *
 * allowEmptyInput = true: Ein leerer String im Inspektor löst keine Meldung aus.
 */
fun Inspector<String>.validateUsingRegex(
    regex: Regex,
    emptyMessage: String = KupoValidationMessages.EMPTY_INPUT,
    notMatchMessage: String = KupoValidationMessages.NO_MATCH_HELP,
    allowEmptyInput: Boolean = false
): List<ComponentValidationMessage> {
    return if (data.isEmpty()) {
        if (allowEmptyInput) emptyList() else listOf(
            ComponentValidationMessage(path, Severity.Error, emptyMessage)
        )
    } else if (!regex.matches(data)) {
        listOf(
            ComponentValidationMessage(path, Severity.Error, notMatchMessage)
        )
    } else emptyList()
}